export const extensionsFile = 'console-extensions.json';

// Special key for the "all" namespaces option to avoid a potential clash with actual namespace names
export const ALL_NAMESPACES_KEY = '#ALL_NS#';

/** Default name of the global plugin entry callback function used by PluginLoader */
export const REMOTE_ENTRY_CALLBACK = '__load_plugin_entry__';
